"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var redux_thunk_1 = __importDefault(require("redux-thunk"));
var global_1 = __importDefault(require("./stores/global"));
var notifications_1 = __importDefault(require("./stores/notifications"));
var point_1 = __importDefault(require("./stores/point"));
var playlist_1 = __importDefault(require("./stores/playlist"));
var history_1 = __importDefault(require("./stores/history"));
var playbackHistory_1 = __importDefault(require("./stores/playbackHistory"));
var mediafiles_1 = __importDefault(require("./stores/mediafiles"));
var mediafilesMeta_1 = __importDefault(require("./stores/mediafilesMeta"));
var player_1 = __importDefault(require("./stores/player"));
var generation_1 = __importDefault(require("./stores/generation"));
var caching_1 = __importDefault(require("./stores/caching"));
var reactions_1 = __importDefault(require("./stores/reactions"));
var baseReducers = {
    global: global_1.default,
    notifications: notifications_1.default,
    point: point_1.default,
    playlist: playlist_1.default,
    history: history_1.default,
    playbackHistory: playbackHistory_1.default,
    mediafiles: mediafiles_1.default,
    mediafilesMeta: mediafilesMeta_1.default,
    player: player_1.default,
    generation: generation_1.default,
    caching: caching_1.default,
    reactions: reactions_1.default,
};
var _global = globalThis;
var composeEnhancers = _global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? _global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : redux_1.compose;
function createStore(initialState, extraMiddlewares, extraReducers) {
    if (extraMiddlewares === void 0) { extraMiddlewares = []; }
    var rootReducer = (0, redux_1.combineReducers)(__assign(__assign({}, baseReducers), extraReducers));
    return (0, redux_1.createStore)(rootReducer, initialState, composeEnhancers(redux_1.applyMiddleware.apply(void 0, __spreadArray([redux_thunk_1.default], __read(extraMiddlewares), false))));
}
exports.default = createStore;
//# sourceMappingURL=store.js.map